// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__sYwLg","alertIcon":"ConfirmModal_alertIcon__2NdGJ"};